import type { SupportRequestsListRow } from "@/admin/entities/assistant";
import type { SupportRequestsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: SupportRequestsListRow[];
  count: number;
} {
  const requests = (data as SupportRequestsListQueryType)?.supportRequests;
  if (!requests || !requests.nodes) {
    return { nodes: [], count: 0 };
  }
  return requests;
}

export function mapColumns(row: SupportRequestsListRow) {
  return [row.id, row, row, row, row, row.status, row.createdAt];
}
